import { PackagePartDto, PackagePartEntity } from '../interfaces';
import { Core } from '../../core';

export const PackagePartsStore = Core.Stores.create<PackagePartEntity, PackagePartDto>(
  '/parts/packages',
);
